export default __webpack_public_path__ + "svg/calendar/2026/2/abril.svg?82441eb7";